"use client";

import { Button, Heading, Logo } from "@texturehq/edges";
import { useSearchParams } from "next/navigation";
import { getOAuthLoginUrl } from "@/lib/oauth";

export default function SignInPage() {
  const searchParams = useSearchParams();
  const error = searchParams.get("error");

  const handleLogin = () => {
    window.location.href = getOAuthLoginUrl();
  };

  return (
    <div className="flex flex-col items-center gap-10">
      <div className="flex flex-col items-center gap-4">
        <Logo showWordmark={false} width={48} />
        <span className="rounded-full border border-action-brand/20 bg-action-brand/10 px-3 py-1 text-xs font-medium text-action-brand">
          Team
        </span>
      </div>

      <div className="flex w-full flex-col items-center gap-8 rounded-lg px-8 py-10 md:border md:border-border-muted">
        <div className="flex flex-col items-center gap-2 text-center">
          <Heading size="xl" tag="h1" height="page">
            Sign in
          </Heading>
          <p className="text-lg text-text-muted">Admin Portal</p>
        </div>

        {error && (
          <div className="w-full max-w-xs rounded-md bg-feedback-error-background p-3 text-center text-sm text-feedback-error-text">
            {error}
          </div>
        )}

        <Button variant="primary" size="lg" onPress={handleLogin} className="min-w-[200px]">
          Continue
        </Button>

        <p className="text-center text-xs text-text-muted">For Texture employees</p>
      </div>
    </div>
  );
}
